import React from "react";

export function EmptyState({ title, message, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center fade-up" data-testid="empty-state">
      <div className="h-14 w-14 rounded-2xl bg-[#007AFF]/10 border border-[#007AFF]/30 flex items-center justify-center mb-5">
        <span className="text-2xl">📊</span>
      </div>
      <h3 className="font-head text-xl font-bold text-white">{title}</h3>
      <p className="mt-2 text-sm text-[#A3A3A3] max-w-sm">{message}</p>
      {action}
    </div>
  );
}

export function Loading() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="h-8 w-8 rounded-full border-2 border-[#262626] border-t-[#007AFF] animate-spin" />
    </div>
  );
}

export function ChartTooltip({ active, payload, label, currency, moneyKeys = [] }) {
  if (!active || !payload || !payload.length) return null;
  const sym = { USD: "$", GBP: "£", EUR: "€" }[currency] || "";
  return (
    <div className="bg-[#0a0a0a] border border-[#262626] rounded-lg px-3 py-2 shadow-xl">
      <p className="text-xs text-[#A3A3A3] mb-1">{label}</p>
      {payload.map((p, i) => (
        <p key={i} className="text-sm font-semibold tnum" style={{ color: p.color || p.fill }}>
          {p.name}: {moneyKeys.includes(p.dataKey) ? sym : ""}
          {Number(p.value).toLocaleString(undefined, { maximumFractionDigits: 2 })}
        </p>
      ))}
    </div>
  );
}
